import { NavLink } from '../component/header';

export const getHeaderLinks = (): Array<NavLink> => [
  { name: 'OASIS', url: 'https://oasis.curtin.edu.au' },
  { name: 'Current students', url: 'https://www.curtin.edu.au/students/' },
  { name: 'Blackboard', url: 'https://lms.curtin.edu.au' },
  {
    name: 'Policies and guidelines',
    url: 'https://www.curtin.edu.au/about/governance/compliance-legal/find-a-policy/'
  }
];
